import { Routes } from '@angular/router';
import { authGuard } from './shared/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/chat',
    pathMatch: 'full',
  },
  {
    path: '',
    canActivate: [authGuard],
    children: [
      {
        path: 'chat',
        loadComponent: () => import('./pages/chat/chat.component').then(m => m.ChatComponent),
      },
      {
        path: 'documents',
        loadComponent: () => import('./pages/documents/documents.component').then(m => m.DocumentsComponent),
      },
      {
        path: 'glossary',
        loadComponent: () => import('./pages/documents/components/glossary-list/glossary-list.component').then(m => m.GlossaryListComponent),
      }
    ],
  },
  {
    path: 'auth',
    children: [
      {
        path: 'login',
        loadComponent: () => import('./pages/auth/login/login.component').then(m => m.LoginComponent),
      },
    ],
  },
  {
    path: 'legal',
    children: [
      {
        path: 'terms',
        loadComponent: () => import('./pages/legal/terms/terms.component').then(m => m.TermsComponent),
      },
      {
        path: 'data-policy',
        loadComponent: () => import('./pages/legal/data-policy/data-policy.component').then(m => m.DataPolicyComponent),
      },
    ],
  },
];
